import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { resetAll } from "./actions/resetAll";

const initialState = "var(--mu-azul-solido, #00f)"

export const corLinearProgressSlice = createSlice({
    name: "corLinearprogress",
    initialState,
    extraReducers: builder => builder.addCase(resetAll, () => initialState),
    reducers: {
        atualizar: (_cor, action: PayloadAction<string>) => action.payload
    }
})

export const {
    atualizar: atualizarAction
}: {
    atualizar: ActionType<string>
} = corLinearProgressSlice.actions

export default corLinearProgressSlice.reducer